import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openPopup } from "../reducers/popup";
import { POPUP_NAME, STATUS_CAMPAIGN } from "../utilities/constants";
const ItemSinger = ({ data, disableVote, needLogin }) => {
  const { avatar_url, name, description } = data || {};
  const dispatch = useDispatch();
  const statusCampaign = useSelector((state) => state?.user?.statusCampaign);

  const handleVote = () => {
    if (statusCampaign === STATUS_CAMPAIGN.NOT_STARTED) {
      dispatch(openPopup({ name: POPUP_NAME.SHOW_NOT_STARTED }));
      return;
    }
    if (statusCampaign === STATUS_CAMPAIGN.ENDED) {
      dispatch(openPopup({ name: POPUP_NAME.SHOW_ENDED }));
      return;
    }
    if (disableVote) {
      dispatch(openPopup({ name: POPUP_NAME.NO_TURN_VOTING }));
    } else if (needLogin) {
      dispatch(openPopup({ name: POPUP_NAME.LOGIN }));
    } else {
      dispatch(openPopup({ name: POPUP_NAME.USER_VOTING, singer: data }));
    }
  };

  return (
    <div className="flex items-center justify-center space-x-2 md:space-x-4 md:py-6 md:px-8 hover:bg-radial-bottom bg-blend-multiply">
      <div className="flex-none text-[5vw] font-bold text-white md:w-8 text-center flex items-center mr-[4vw]">
        {description}
      </div>
      <div className="shrink w-[15vw] h-[16vw] item-bg">
        {avatar_url && (
          <img
            className="w-full md:h-auto"
            src={avatar_url }
            alt={`ATSH 2024 | ${name}`}
          />
        )}
      </div>
    
      <div className="flex-auto">
        <div className="flex ml-4">
          <div className="flex items-center justify-start w-full">
            <div className="flex flex-col">
              <div className="text-[3vw] font-gilroy font-bold text-white singer-name-shadow uppercase">
                {name}
              </div>
              {/* {description && (
                <div className="text-white font-gilroy text-[3vw] text-opacity-[0.6]">
                 {description}
                </div>
              )} */}
            </div>
          </div>
          <div className="flex lg:flex-row lg:justify-end items-center text-[10px] lg:text-[15px] text-white font-bold">
            <button
              onClick={handleVote}
              className="flex flex-col w-[9.5vw] h-[9.5vw] ml-[1vw] justify-center disabled:bg-img-disabled items-center btn hover:bg-img-hover hover:transition-all bg-cover bg-no-repeat bg-right before:bg-vote-left before:w-[3vw] before:h-[4.5vw]  bg-block-2 border-[#4592a3] border rounded-md a"
              title={`ATSH 2024 | Bình chọn cho ${name}`}
            >
              <span className="pt-[1vw] text-[1.3vw]">Bình chọn</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemSinger;
